import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store.js';

import './index.css';
import App from './App';
import { SDKProvider } from './context/SDKProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <SDKProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </SDKProvider>
  </Provider>
);
